import { createAsyncThunk } from '@reduxjs/toolkit';
import { formatApiError } from '@/utils';
import { IApiError } from '@/models/apiError.model';
import { SLICE_NAME } from './models';
import { OrdersAPI } from '@/api';
import { IPushOrderDTO, IPushOrderResponse } from '@/models/order.model';

export const pushOrder = createAsyncThunk<IPushOrderResponse, IPushOrderDTO, { serializedErrorType: IApiError }>(
  `${SLICE_NAME}/pushOrder`,
  async (params) => {
    const response = await OrdersAPI.pushOrder(params);
    return response.data;
  },
  { serializeError: formatApiError },
);
